module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNsptJUl8tHj8f////O4fBgns7z+Pu20umdxOHn8Ph4rdapy+WRvN3C2uza6fR8HTjuAAAAB3RSTlMAYL8AIM/vi50ITwAAAM1JREFUeF7t2GkKwjAUhdGMfZk7OOx/qbYICrWCSa4g8r4FHPIrJFdsSUUdKanXhNbGUmfWbJAZqLvBrJAlQFYLSZCkUBhICQL1fxBDbp9vgcIYX0u5GgrXeFQJtdAUj5tqofkNlGqh+G3oBIKKx0Bzpmbo7J6tTDvkaFcDxBBD4/QoN0P7UgBBMaGg6FGQ+zVoJhDkIFC58MXGEEMMNTxGfSc0Pu7ETsiXO7T0QpTTdp4F8anxLvPHj6FPgo0ssNkHNUTBpjHkWLeGmA9v30+Xt4CKd7IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1eb.png
// module id = 595
// module chunks = 0